<script setup lang="ts">
import { mergeDefaults as __MACROS_mergeDefaults } from "vue";
/**
 * WIP: Agent markdown pre component
 */

defineProps(__MACROS_mergeDefaults({
  code: null,
  language: null,
  filename: null,
  highlights: null,
  meta: null
}, { code: "", }))
const { copyTextToClipboard } = useClipboard()
</script>

<template>
  <section class="pre-container group">
    <div class="copy-button" @click="copyTextToClipboard(code)">
      <icon-property
        type="copy"
        size="2xs"
        class="copy-icon"
      />
    </div>
    <pre :class="$props.class">
      <slot />
    </pre>
  </section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.pre-container
  @apply relative

pre
  @apply -m-2.5 p-2.5 bg-[#{$global-steel-accent}] overflow-x-auto flex
  @apply text-[#{$global-fs-base}]

  code .line
    @apply block

.copy-button
  @apply absolute right-0 top-2.5 cursor-pointer
  @apply invisible group-hover:visible
  &:hover
    .copy-icon
      @apply text-[#{$global-bg-icon-primary}]
.copy-icon
  @apply text-[#{$global-bg-icon-secondary}]
</style>
